import { Activation } from "@/types";
import {
  ActivationAction,
  ActivationState,
  CHANGE_ACTIVATION,
  LOAD_ACTIVATION,
  SHARE_ACTIVATION,
} from "./types";

const hasChanges = (activation: Activation, changes: Partial<Activation>) =>
  (Object.keys(changes) as (keyof Activation)[]).some((key) => activation[key] !== changes[key]);

export const activationReducer = (
  state: ActivationState,
  action: ActivationAction
): ActivationState => {
  switch (action.type) {

    case LOAD_ACTIVATION:
      if (state.currentActivation === action.payload) return state;
      return { ...state, currentActivation: action.payload };

    // Merges changed fields into the current activation
    case CHANGE_ACTIVATION: {
      const current = state.currentActivation;
      if (!current || !hasChanges(current, action.payload)) return state;
      return { ...state, currentActivation: { ...current, ...action.payload } };
    }

    case SHARE_ACTIVATION: {
      const { campaignId, userIds } = action.payload;
      if (state.currentActivation?.campaign_id !== campaignId) return state;
      return { ...state, currentActivation: { ...state.currentActivation, shared_with: userIds } };
    }

    default:
      return state;
  }
};
